import React, { useState, useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { CONTINUOUS_FEEDBACK_RELOAD_TYPE, REVIEW_TEXTS } from 'constants/ProjectConstants';

import { getArchivedReviews } from 'services/performanceReview';
import { showErrorSnackbar } from 'services/snackbar';

import ReviewsList from './common/ReviewsList';

const ArchivedReviews = ({ clearReloadType, reloadType, loggedInEmployee }) => {
  const [reviewList, setReviewList] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [count, setCount] = useState(null);
  const [filter, setFilter] = useState('filter');
  const [loading, setLoading] = useState(false);
  const limit = 5;

  const dispatch = useDispatch();

  const fetchReviews = () => {
    setLoading(true);
    const offset = currentPage * limit;
    getArchivedReviews({ limit, offset, includeCount: true })
      .then(({ totalCount, reviews }) => {
        setCount(totalCount);
        setReviewList(reviews);
      })
      .catch((err) => {
        dispatch(showErrorSnackbar(err.message || 'Some error occured'));
      })
      .finally(() => setLoading(false));
  };

  useEffect(fetchReviews, [currentPage]);

  useEffect(() => {
    setCurrentPage(0);
    fetchReviews();
  }, [filter]);

  useEffect(() => {
    if (reloadType === CONTINUOUS_FEEDBACK_RELOAD_TYPE.ARCHIVED) {
      setCurrentPage(0);
      fetchReviews();
      clearReloadType();
    }
  }, [reloadType]);

  const removeFromReviewsList = (reviewId, employeeId) =>
    setReviewList(
      reviewList.filter((r) => r.review.feedbackForm.id !== reviewId || r.review.receiverEmployeeId !== employeeId)
    );

  const updatePeerStatus = (reviewId, employeeId) =>
    setReviewList(
      reviewList.map((r) => {
        if (r.review.feedbackForm.id === reviewId && r.review.receiverEmployeeId === employeeId) {
          // eslint-disable-next-line no-param-reassign
          r.review.peerStatus = null;
        }
        return r;
      })
    );

  return (
    <ReviewsList
      title="Completed Reviews"
      loading={loading}
      reviewList={reviewList}
      removeFromReviewsList={removeFromReviewsList}
      updatePeerStatus={updatePeerStatus}
      currentPage={currentPage}
      count={count}
      limit={limit}
      setCurrentPage={setCurrentPage}
      filter={filter}
      setFilter={setFilter}
      errorMessage={REVIEW_TEXTS.LANDING_PAGE_ARCHIVED_REVIEWS.ERROR_MSG}
      noDataMessage={REVIEW_TEXTS.LANDING_PAGE_ARCHIVED_REVIEWS.NO_DATA}
      showDateColumn={false}
      loggedInEmployee={loggedInEmployee}
    />
  );
};

export default ArchivedReviews;
